<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :filterData="scopedFilterData"
      :apiUrl="apiUrl">

      <template #filter="scope">
        <div class="row mt-2">
          <div class="col col-6">
            <div class="form-group row">
              <label class="col-sm-4 col-form-label text-center">Tahun</label>
              <div class="col-sm-8">
                <v-select v-model="scopedFilterData.year" :options="$constant.LIST_YEARS"  @input="onRefresh"/>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #form="scope">
        <div class="form-group">
          <label>Nama Hari Libur</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name">
        </div>

        <div class="form-group">
          <label>Informasi</label>
          <input class="form-control d-block w-100" v-model="scope.data.Information">
        </div>

        <div class="form-group">
          <label>Tanggal</label>
          <b-form-datepicker v-model="scope.data.Date" locale="id" class="mb-2"></b-form-datepicker>
        </div>

        <div class="custom-control custom-switch mb-3">
          <input type="checkbox" class="custom-control-input" id="formActive" v-model="scope.data.Active">
          <label class="custom-control-label" for="formActive">Aktif ?</label>
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

    </AppToolbox>

    <AppTable 
      :apiUrl="apiUrl" 
      :fields="tableFields" 
      :search="search" 
      :filter="scopedFilterData" 
      @onSelectItem="selectedItem = $event" 
    />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()
  },
  data() {
    return {
      apiUrl: '/holiday',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Hari Libur' },
        { key: 'Information', label: 'Informasi' },
        { key: 'Date', label: 'Tanggal', formatter: value => this.$helper.formatDate(value) },
        { key: 'Active', label: 'Aktif', formatter: value => {
          if (value === 1) {
            return '<span class="badge badge-success">Iya</span>'
          } else {
            return '<span class="badge badge-danger">Tidak</span>'
          }
        }}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        Name: '',
        Information: '',
        Date: '',
        Active: false
      },
      scopedFilterData: {
        year: (new Date()).getFullYear()
      },
      scopedDetailData: {}
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    }
  }
}
</script>
